import {useNetwork} from "../../hooks/useNetwork";
import Typography from "@mui/material/Typography";
import React from "react";
import {EditWrapper} from "../EditWrapper";
import useAuth from "../../routes/login/AuthContext";
import {useNetworkContext} from "../../contexts/NetworkContext/context";
import {UpdateNetwork} from "../../services/NetworkApi";


interface IProps {
  isPreview: boolean;
}

export const NetworkBioEnabled: React.FC<IProps> = (props) => {
  const { getAuthToken } = useAuth();
  const { updateNetworkValues } = useNetworkContext();
  const { selectedNetwork } = useNetwork();

  const handleUpdate = async (setting: string) => {
    let updateValue = null;
    if (setting === "True") {
      updateValue = true;
    } else if (setting === "False") {
      updateValue = false;
    }

    if (updateValue !== null) {
      await UpdateNetwork(
          selectedNetwork.l1Id,
          { networkName: selectedNetwork.l1Name, bioEnabled: updateValue },
          await getAuthToken()
      );

      return updateNetworkValues(selectedNetwork.l1Id, {
        bioEnabled: updateValue,
      });
    }
  };

  const defaultValue = selectedNetwork.bioEnabled ? "True" : "False";
  return (
      <>
        {props.isPreview && (
            <Typography variant="subtitle1">
              Resident Bio Enabled: {defaultValue}
            </Typography>
        )}
        {!props.isPreview && (
            <EditWrapper options={["True", "False"]}
                         onEditSuccess={handleUpdate}
                         defaultValue={defaultValue}
                >
                <Typography variant="subtitle1">
                  Resident Bio Enabled: {defaultValue}
                </Typography>
            </EditWrapper>
      )}
      </>
  );
};